export const PROCESS_DONE_SMOKING_DYING_REQUEST = "PROCESS_DONE_SMOKING_DYING_REQUEST";
export const PROCESS_DONE_SMOKING_DYING_SUCCESS = "PROCESS_DONE_SMOKING_DYING_SUCCESS";
export const PROCESS_DONE_SMOKING_DYING_FAILED = "PROCESS_DONE_SMOKING_DYING_FAILED";
